import { Component, Vue } from 'vue-property-decorator';
import { TermsAcceptance } from '@/api';
import { authModule } from '@/store';

/**
 * Recording a logged-in user's acceptance of the current T&Cs.
 *
 * Extracted from the old `TermsAlert` when the bid-gate popup became a second
 * place that has to do exactly this, and now shared by `VerificationGateDialog`
 * and `views/AccountNotices.vue`. They differ in what they show afterwards, not
 * in what they record, so the request and the store update live here and the
 * components keep their own visibility state.
 */
@Component
export default class AcceptTerms extends Vue {
  accepting: boolean = false;

  acceptError: string = '';

  /** Records an acceptance. Returns whether it went through. */
  async acceptTerms(): Promise<boolean> {
    this.accepting = true;
    this.acceptError = '';
    try {
      const { ok, user } = await TermsAcceptance.accept();
      if (!ok) {
        throw new Error('acceptance rejected');
      }
      // The 201 sideloads the user, so the refreshed status costs no second
      // request. Falling back to false is safe rather than optimistic: an
      // acceptance was just recorded against the current version.
      const stored = authModule.user;
      if (stored) {
        stored.termsAcceptanceRequired = user
          ? user.termsAcceptanceRequired
          : false;
        stored.hasAcceptedCurrentTerms = true;
      }
      return true;
    } catch (e) {
      this.acceptError = 'That did not go through just now. Please try again.';
      return false;
    } finally {
      this.accepting = false;
    }
  }
}
